module.exports = __webpack_public_path__ + "img/select-3-1.b06e60a1.png";